import { api, ReactQueryOptions, RouterInputs } from '@api';
type optionsType = ReactQueryOptions['StoreManager']['countStoreItems'];
type inputType = RouterInputs['StoreManager']['countStoreItems'];
export const useGetCountStoreItems = (input: inputType, options?: optionsType) => api.StoreManager.countStoreItems.useQuery(input, {
  queryKey: ['StoreManager.countStoreItems', input],
  staleTime: 15 * 60 * 1000,
  // 15 mins
  ...options
});